import { Injectable } from '@angular/core';
import { Observable, of, throwError, timer } from 'rxjs';
import { delay, mergeMap } from 'rxjs/operators';
import { ViolationsModels } from '@share-models';
import { decodeCalendarRangeAbsoluteBounds } from '@ui';

export interface ViolationsPagedResponse {
  items: ViolationsModels.Violation[];
  nextCursor: string | null;
  hasMore: boolean;
}

const MOCK_VIOLATIONS: ViolationsModels.Violation[] = [
  {
    id: 'V-1001',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1001',
    type: ViolationsModels.ViolationType.RedLight,
    status: ViolationsModels.ViolationStatus.Pending,
    viewedBy: 'User 1',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 8,
  },
  {
    id: 'V-1002',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1002',
    type: ViolationsModels.ViolationType.DoubleParking,
    status: ViolationsModels.ViolationStatus.Denied,
    viewedBy: 'User 2',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 15,
  },
  {
    id: 'V-1003',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1003',
    type: ViolationsModels.ViolationType.WrongWay,
    status: ViolationsModels.ViolationStatus.Approved,
    viewedBy: 'User 3',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 12,
  },
  {
    id: 'V-1004',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1004',
    type: ViolationsModels.ViolationType.Speeding,
    status: ViolationsModels.ViolationStatus.Pending,
    viewedBy: 'User 4',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 15,
  },
  {
    id: 'V-1005',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1005',
    type: ViolationsModels.ViolationType.RedLight,
    status: ViolationsModels.ViolationStatus.Denied,
    viewedBy: 'User 5',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 6,
  },
  {
    id: 'V-1006',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1006',
    type: ViolationsModels.ViolationType.DoubleParking,
    status: ViolationsModels.ViolationStatus.Approved,
    viewedBy: 'User 6',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 15,
  },
  {
    id: 'V-1007',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1007',
    type: ViolationsModels.ViolationType.WrongWay,
    status: ViolationsModels.ViolationStatus.Pending,
    viewedBy: 'User 7',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 10,
  },
  {
    id: 'V-1008',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1008',
    type: ViolationsModels.ViolationType.Speeding,
    status: ViolationsModels.ViolationStatus.Denied,
    viewedBy: 'User 8',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 15,
  },
  {
    id: 'V-1009',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1009',
    type: ViolationsModels.ViolationType.RedLight,
    status: ViolationsModels.ViolationStatus.Approved,
    viewedBy: 'User 9',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 15,
  },
  {
    id: 'V-1010',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1010',
    type: ViolationsModels.ViolationType.DoubleParking,
    status: ViolationsModels.ViolationStatus.Pending,
    viewedBy: 'User 10',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 15,
  },
  {
    id: 'V-1011',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1011',
    type: ViolationsModels.ViolationType.WrongWay,
    status: ViolationsModels.ViolationStatus.Denied,
    viewedBy: 'User 11',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 8,
  },
  {
    id: 'V-1012',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1012',
    type: ViolationsModels.ViolationType.Speeding,
    status: ViolationsModels.ViolationStatus.Approved,
    viewedBy: 'User 12',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 10,
  },
  {
    id: 'V-1013',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1013',
    type: ViolationsModels.ViolationType.RedLight,
    status: ViolationsModels.ViolationStatus.Pending,
    viewedBy: 'User 13',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 12,
  },
  {
    id: 'V-1014',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1014',
    type: ViolationsModels.ViolationType.DoubleParking,
    status: ViolationsModels.ViolationStatus.Denied,
    viewedBy: 'User 14',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 15,
  },
  {
    id: 'V-1015',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1015',
    type: ViolationsModels.ViolationType.WrongWay,
    status: ViolationsModels.ViolationStatus.Approved,
    viewedBy: 'User 15',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 6,
  },
  {
    id: 'V-1016',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1016',
    type: ViolationsModels.ViolationType.Speeding,
    status: ViolationsModels.ViolationStatus.Pending,
    viewedBy: 'User 16',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 11,
  },
  {
    id: 'V-1017',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1017',
    type: ViolationsModels.ViolationType.RedLight,
    status: ViolationsModels.ViolationStatus.Denied,
    viewedBy: 'User 17',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 10,
  },
  {
    id: 'V-1018',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1018',
    type: ViolationsModels.ViolationType.DoubleParking,
    status: ViolationsModels.ViolationStatus.Approved,
    viewedBy: 'User 18',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 14,
  },
  {
    id: 'V-1019',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1019',
    type: ViolationsModels.ViolationType.WrongWay,
    status: ViolationsModels.ViolationStatus.Pending,
    viewedBy: 'User 19',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 15,
  },
  {
    id: 'V-1020',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1020',
    type: ViolationsModels.ViolationType.Speeding,
    status: ViolationsModels.ViolationStatus.Denied,
    viewedBy: 'User 20',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 12,
  },
  {
    id: 'V-1021',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1021',
    type: ViolationsModels.ViolationType.RedLight,
    status: ViolationsModels.ViolationStatus.Approved,
    viewedBy: 'User 21',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 8,
  },
  {
    id: 'V-1022',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1022',
    type: ViolationsModels.ViolationType.DoubleParking,
    status: ViolationsModels.ViolationStatus.Pending,
    viewedBy: 'User 22',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 15,
  },
  {
    id: 'V-1023',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1023',
    type: ViolationsModels.ViolationType.WrongWay,
    status: ViolationsModels.ViolationStatus.Denied,
    viewedBy: 'User 23',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 12,
  },
  {
    id: 'V-1024',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1024',
    type: ViolationsModels.ViolationType.Speeding,
    status: ViolationsModels.ViolationStatus.Approved,
    viewedBy: 'User 24',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 15,
  },
  {
    id: 'V-1025',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1025',
    type: ViolationsModels.ViolationType.RedLight,
    status: ViolationsModels.ViolationStatus.Pending,
    viewedBy: 'User 25',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 6,
  },
  {
    id: 'V-1026',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1026',
    type: ViolationsModels.ViolationType.DoubleParking,
    status: ViolationsModels.ViolationStatus.Denied,
    viewedBy: 'User 26',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 15,
  },
  {
    id: 'V-1027',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1027',
    type: ViolationsModels.ViolationType.WrongWay,
    status: ViolationsModels.ViolationStatus.Approved,
    viewedBy: 'User 27',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 10,
  },
  {
    id: 'V-1028',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1028',
    type: ViolationsModels.ViolationType.Speeding,
    status: ViolationsModels.ViolationStatus.Pending,
    viewedBy: 'User 28',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 11,
  },
  {
    id: 'V-1029',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1029',
    type: ViolationsModels.ViolationType.RedLight,
    status: ViolationsModels.ViolationStatus.Denied,
    viewedBy: 'User 29',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 15,
  },
  {
    id: 'V-1030',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1030',
    type: ViolationsModels.ViolationType.DoubleParking,
    status: ViolationsModels.ViolationStatus.Approved,
    viewedBy: 'User 30',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 10,
  },
  {
    id: 'V-1031',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1031',
    type: ViolationsModels.ViolationType.WrongWay,
    status: ViolationsModels.ViolationStatus.Pending,
    viewedBy: 'User 31',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 8,
  },
  {
    id: 'V-1032',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1032',
    type: ViolationsModels.ViolationType.Speeding,
    status: ViolationsModels.ViolationStatus.Denied,
    viewedBy: 'User 32',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 13,
  },
  {
    id: 'V-1033',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1033',
    type: ViolationsModels.ViolationType.RedLight,
    status: ViolationsModels.ViolationStatus.Approved,
    viewedBy: 'User 33',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 12,
  },
  {
    id: 'V-1034',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1034',
    type: ViolationsModels.ViolationType.DoubleParking,
    status: ViolationsModels.ViolationStatus.Pending,
    viewedBy: 'User 34',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 44,
  },
  {
    id: 'V-1035',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1035',
    type: ViolationsModels.ViolationType.WrongWay,
    status: ViolationsModels.ViolationStatus.Denied,
    viewedBy: 'User 35',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 6,
  },
  {
    id: 'V-1036',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1036',
    type: ViolationsModels.ViolationType.Speeding,
    status: ViolationsModels.ViolationStatus.Approved,
    viewedBy: 'User 36',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 99,
  },
  {
    id: 'V-1037',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1037',
    type: ViolationsModels.ViolationType.RedLight,
    status: ViolationsModels.ViolationStatus.Pending,
    viewedBy: 'User 37',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 10,
  },
  {
    id: 'V-1038',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1038',
    type: ViolationsModels.ViolationType.DoubleParking,
    status: ViolationsModels.ViolationStatus.Denied,
    viewedBy: 'User 38',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 124,
  },
  {
    id: 'V-1039',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1039',
    type: ViolationsModels.ViolationType.WrongWay,
    status: ViolationsModels.ViolationStatus.Approved,
    viewedBy: 'User 39',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 15,
  },
  {
    id: 'V-1040',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1040',
    type: ViolationsModels.ViolationType.Speeding,
    status: ViolationsModels.ViolationStatus.Pending,
    viewedBy: 'User 40',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 11,
  },
  {
    id: 'V-1041',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1041',
    type: ViolationsModels.ViolationType.RedLight,
    status: ViolationsModels.ViolationStatus.Denied,
    viewedBy: 'User 41',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 8,
  },
  {
    id: 'V-1042',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1042',
    type: ViolationsModels.ViolationType.DoubleParking,
    status: ViolationsModels.ViolationStatus.Approved,
    viewedBy: 'User 42',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 94,
  },
  {
    id: 'V-1043',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1043',
    type: ViolationsModels.ViolationType.WrongWay,
    status: ViolationsModels.ViolationStatus.Pending,
    viewedBy: 'User 43',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 12,
  },
  {
    id: 'V-1044',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1044',
    type: ViolationsModels.ViolationType.Speeding,
    status: ViolationsModels.ViolationStatus.Denied,
    viewedBy: 'User 44',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 15,
  },
  {
    id: 'V-1045',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1045',
    type: ViolationsModels.ViolationType.RedLight,
    status: ViolationsModels.ViolationStatus.Approved,
    viewedBy: 'User 45',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 6,
  },
  {
    id: 'V-1046',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1046',
    type: ViolationsModels.ViolationType.DoubleParking,
    status: ViolationsModels.ViolationStatus.Pending,
    viewedBy: 'User 46',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 15,
  },
  {
    id: 'V-1047',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1047',
    type: ViolationsModels.ViolationType.WrongWay,
    status: ViolationsModels.ViolationStatus.Denied,
    viewedBy: 'User 47',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 10,
  },
  {
    id: 'V-1048',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1048',
    type: ViolationsModels.ViolationType.Speeding,
    status: ViolationsModels.ViolationStatus.Approved,
    viewedBy: 'User 48',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 15,
  },
  {
    id: 'V-1049',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1049',
    type: ViolationsModels.ViolationType.RedLight,
    status: ViolationsModels.ViolationStatus.Pending,
    viewedBy: 'User 49',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 15,
  },
  {
    id: 'V-1050',
    previewUrl: 'https://picsum.photos/200/300',
    licensePlate: 'LP-1050',
    type: ViolationsModels.ViolationType.DoubleParking,
    status: ViolationsModels.ViolationStatus.Denied,
    viewedBy: 'User 50',
    location: '3rd Avenue & 22nd St, New York, NY',
    date: '11/05/1990',
    duration: 15,
  }
];

const SHOULD_ERROR = false;

@Injectable({ providedIn: 'root' })
export class ViolationsService {
  public getViolations(
    cursor: string | null,
    limit: number,
    filters: ViolationsModels.Filters.ViolationsFilters = {},
  ): Observable<ViolationsPagedResponse> {
    if (SHOULD_ERROR) {
      return timer(500).pipe(
        mergeMap(() =>
          throwError(() => new Error('Failed to load violations.')),
        ),
      );
    }

    let filtered = MOCK_VIOLATIONS.slice();

    const query = filters.query?.trim().toLowerCase();
    if (query) {
      filtered = filtered.filter(
        (v) =>
          v.licensePlate.toLowerCase().includes(query) ||
          v.id.toLowerCase().includes(query) ||
          v.location.toLowerCase().includes(query),
      );
    }

    if (filters.location?.trim()) {
      const loc = filters.location.trim().toLowerCase();
      filtered = filtered.filter((v) =>
        v.location.toLowerCase().includes(loc),
      );
    }

    if (filters.statuses?.length) {
      filtered = filtered.filter((v) =>
        filters.statuses!.includes(v.status),
      );
    }

    if (filters.types?.length) {
      filtered = filtered.filter((v) => filters.types!.includes(v.type));
    }

    if (filters.dateRange) {
      const bounds = decodeCalendarRangeAbsoluteBounds(filters.dateRange);
      if (bounds) {
        const { from, to } = bounds;
        filtered = filtered.filter((v) => {
          const d = new Date(v.date).getTime();
          return d >= from && d <= to;
        });
      }
    }

    const total = filtered.length;
    const requestedStart = cursor == null ? 0 : Number(cursor);
    const start = Number.isFinite(requestedStart) ? requestedStart : 0;
    const end = start + limit;
    const items = filtered.slice(start, end);
    const hasMore = end < total;
    const nextCursor = hasMore ? String(end) : null;

    return of({ items, nextCursor, hasMore }).pipe(delay(500));
  }
}
